import React from "react";
import { useTranslation } from "react-i18next";
import { Props } from "./types";
import { Form } from "./form";
import { FlashReportIcon } from "./flashReportIcon";
import styles from "./styles.scss";

function PdfExport(props: Props) {
  const [isOpen, setIsOpen] = React.useState(false);
  const { t } = useTranslation();

  return (
    <div className={styles.pdfExport}>
      <button className={styles.link} onClick={() => setIsOpen(true)}>
        <FlashReportIcon className={styles.icon} />
        <p>{t("projectPage.synthesisPage.pdfExport.title")}</p>
      </button>
      {isOpen && (
        <Form
          project={props.project}
          synthesis={props.synthesis}
          close={() => setIsOpen(false)}
        />
      )}
    </div>
  );
}

export { PdfExport };
